// @flow

import Markdoc from '@stripe-internal/markdoc';

import type {RenderTag} from '@stripe-internal/markdoc';
import type {Config} from 'docs/markdoc';

const tokenizer = new Markdoc.Tokenizer({typographer: true});

// TODO(DOCSPRODUCT-708): Create better system for rendering Markdown from Ruby
export function unsafelyParseMarkdown(
  string: string,
  config: Config,
): RenderTag | Array<RenderTag> {
  try {
    const tokens = tokenizer.tokenize(string);
    const mdast = Markdoc.parse(tokens);
    return Markdoc.process(mdast, config);
  } catch {
    return '';
  }
}
